import { all, fork, call, put, takeLatest } from 'redux-saga/effects'

import { constants } from '../../../modules/reports/financial/maintenanceFinancialsReportActions'
import * as api from '../../../api/reports/financial/maintenanceFinancialsReport'

function* maintenanceFinancialsReportGetOrganizationList(action) {
  try {
    const payload = yield call(api.getOrganizationList, action.filters)
    yield put({
      type: constants.MAINTENANCE_FINANCIALS_REPORT_GET_ORGANIZATION_LIST.SUCCESS,
      payload
    })
  } catch (e) {
    console.log(e)
    Raven.captureException(e)
    yield put({
      type: constants.MAINTENANCE_FINANCIALS_REPORT_GET_ORGANIZATION_LIST.FAILED,
      message: e.message || e
    })
  }
}

function* maintenanceFinancialsReportGetFullReport(action) {
  try {
    const payload = yield call(api.getFullReport, action.filters)
    yield put({ type: constants.MAINTENANCE_FINANCIALS_REPORT_GET_FULL_REPORT.SUCCESS, payload })
  } catch (e) {
    console.log(e)
    Raven.captureException(e)
    yield put({
      type: constants.MAINTENANCE_FINANCIALS_REPORT_GET_FULL_REPORT.FAILED,
      message: e.message || e
    })
  }
}

/**
 * Saga
 */

function* watchMaintenanceFinancialsReportGetOrganizationList() {
  yield takeLatest(
    constants.MAINTENANCE_FINANCIALS_REPORT_GET_ORGANIZATION_LIST.ACTION,
    maintenanceFinancialsReportGetOrganizationList
  )
}

function* watchMaintenanceFinancialsReportGetFullReport() {
  yield takeLatest(
    constants.MAINTENANCE_FINANCIALS_REPORT_GET_FULL_REPORT.ACTION,
    maintenanceFinancialsReportGetFullReport
  )
}

/**
 * Export the root saga by forking all available sagas.
 */
export function* rootSaga() {
  // add more sagas here
  yield all([
    fork(watchMaintenanceFinancialsReportGetOrganizationList),
    fork(watchMaintenanceFinancialsReportGetFullReport)
  ])
}



// WEBPACK FOOTER //
// ./src/redux/sagas/reports/financial/maintenanceFinancialsReportSaga.js